module.exports = __webpack_public_path__ + "static/social-image-59f5b07e04a3977d30df168ed292ba05.png";